export const icon = (id) => {
  const icons = {
    6046   : "mdi-soccer",
    54094  : "mdi-tennis-ball",
    154919 : "mdi-boxing-glove",
    48242  : "mdi-basketball",
    154914 : "mdi-baseball",
    154830 : "mdi-volleyball",
    10     : "mdi-trophy-award",
    687890 : "mdi-gamepad-variant-outline",
    131506: "mdi-football",
    621569: "mdi-volleyball",
    265917: "mdi-table-tennis",
    35709: "mdi-handball",
    52: "mdi-sword-cross",
    687887: "mdi-shoe-sneaker",
    54     : "mdi-trophy-award"
  }
  return icons[id]
}